import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#895af8";
function TKS({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  fillRule="evenodd" d="M13.328 10.688q.18-.012.36 0c1.11.074 1.62 1.582 2.324 1.5a6.1 6.1 0 01-2.25 1.162 1.5 1.5 0 01-1.627-.975v3l4.365-2.49V9zm-2.168-.008a1.54 1.54 0 01-.555-1.117v-.06c0-.87 1.402-2.25 1.447-2.25.046.045 1.448 1.387 1.448 2.25v.067a1.5 1.5 0 01-.45 1.02l3.45-1.852L12 6.533 7.5 8.715zm.735 1.725a1.5 1.5 0 01-1.627.982 6.1 6.1 0 01-2.25-1.162c.704.053 1.207-1.463 2.324-1.5q.18-.01.36 0L7.5 9v3.893l4.403 2.542z" clipRule="evenodd" /><path  d="M12 3a9 9 0 100 18 9 9 0 000-18M6.975 8.393L12 5.954l5.032 2.438v4.792L12 16.087l-5.025-2.902zm10.073 6.75l-5.01 2.895-5.07-2.925v-.278l5.07 2.925 5.01-2.895zm0-.563l-5.01 2.895-5.07-2.925v-.3l5.07 2.933 5.01-2.895zm0-.562l-5.01 2.895-5.07-2.925v-.278l5.07 2.932 5.01-2.894z" /></Svg>;
}
TKS.DefaultColor = DefaultColor;
export default TKS;